// extracted by mini-css-extract-plugin
module.exports = {"filterBody":"DesktopFilters_filterBody__WTlpf","accordion":"DesktopFilters_accordion__TwqSM"};